import BlockRenderer from '../../cms/BlockRenderer'
import type { CmsPage as CmsContent } from '../../cms/types'
import type { Route } from '../types'
import { useShopI18n } from '../../i18n'

type Props = {
  route: Route
  pageData: CmsContent | null
  pageLoading: boolean
  pageError: string
}

const CmsPageView = ({ route, pageData, pageLoading, pageError }: Props) => {
  const { t } = useShopI18n()
  const pageTitle = pageData?.title || (route.mode === 'preview' ? t('cms.page.preview') : '')

  return (
    <div className="shop-runtime-stage bg-slate-50 text-slate-900">
      <div className="shop-runtime-grid" />
      <div className="shop-layout space-y-5 py-8">
        <header>
          <div className="mx-auto max-w-4xl text-center">
            {pageTitle && (
              <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">{pageTitle}</h1>
            )}
            {pageData?.excerpt && (
              <p className="mt-2 text-sm text-slate-600">{pageData.excerpt}</p>
            )}
          </div>
        </header>

        {pageLoading && (
          <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm">
            {t('cms.page.loading')}
          </div>
        )}
        {pageError && (
          <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 shadow-sm">
            {pageError}
          </div>
        )}
        {!pageLoading && !pageError && !pageData && (
          <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm">
            {t('cms.page.unavailable')}
          </div>
        )}
        {pageData && !pageError && (
          <BlockRenderer layout={pageData.content} />
        )}
      </div>
    </div>
  )
}

export default CmsPageView
